import { getModifyFlag } from 'selectors';
import { getIsModifyRental } from 'utils/reservation';
import utils from 'utils';
import { openModal } from 'actions/modal/openModal';
import MODALKEYS from 'constants/modals';
import { modifyAbort } from 'actions/reservation/modifyAbort';

/**
 * @name showDiscardReservationModal
 * @desc opens CONFIRM_DISCARD_RESERVATION_MODAL with correct header and isTrueModify flag
 * @param {Object} props - passes any props through to DiscardReservationModalContent, check component propTypes for details
 * @returns function
 * @memberof actions.modal
 * @example
 * dispatch(showDiscardReservationModal({ DiscardReservationModalContent props }));
 */
export const showDiscardReservationModal = (props) => (dispatch, getState) => {
  const isTrueModify = getModifyFlag(getState());
  const redirect = Object.hasOwn(props, 'redirect') ? props.redirect : true;
  const isModifyRental = getIsModifyRental();
  let header = utils.i18n(isTrueModify ? 'true_modify_discard_modal_header' : 'discard_reservation_modal_header');

  if (isModifyRental) {
    header = utils.i18n('discard_all_modifications');
  }

  dispatch(
    openModal(MODALKEYS.CONFIRM_DISCARD_RESERVATION_MODAL, {
      props: {
        header,
        isTrueModify,
        modifyAbortFn: () => dispatch(modifyAbort(redirect)),
        isModifyRental,
        ...props,
      },
    })
  );
};
